"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90976 10.9417C2.4336 10.9417 2 10.551 2 10.0038C2 9.47871 2.40451 9.05835 2.90976 9.05835L14.9036 9.05835L10.6316 4.61883C10.2729 4.24604 10.2729 3.6524 10.6316 3.2796C10.9903 2.9068 11.5616 2.9068 11.9203 3.2796L17.7576 9.34579L17.7713 9.36233C17.8702 9.48234 17.9387 9.62219 17.9737 9.76787L17.99 9.83562L17.99 9.85431C17.9922 9.86889 17.9943 9.88646 17.9957 9.90642C18.0083 10.0465 17.9937 10.1947 17.9441 10.3369C17.9024 10.4622 17.8362 10.5725 17.7428 10.6696L11.9278 16.7126C11.7436 16.9164 11.491 17 11.2796 17C11.0458 17 10.8129 16.9012 10.6389 16.7204C10.2801 16.3476 10.2801 15.754 10.6389 15.3812L14.9109 10.9417L2.90976 10.9417Z",
    fill: "#727B7F"
  }));
};